import AppMenu from "../Page/AppMenu";
import SpotlightSearch from "../SpotlightSearch/SpotlightSearch";
import "./App.styles";
import { queryClient } from "@app/config/api/api";
import { invalidateExperimentDetails } from "@app/queries/experiment";
import { updateExperimentStatus } from "@app/state/actions";
import { useWebSocket } from "@lib/websocket/useWebSocket";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router";

export default function App() {
  const posthog = usePostHog();
  const location = useLocation();

  // Subscribe to experiment status updates via WebSocket.
  useWebSocket("experiment.update", async ({ payload: { id, status } }) => {
    updateExperimentStatus(id, status);
    await invalidateExperimentDetails(id);
  });

  useEffect(() => {
    // Capture pageviews manually on route changes. SDK auto-pageview is disabled in posthog.ts
    // so that no events fire before identify() — this component only renders after the auth guard
    // confirms the user is authenticated and identified.
    posthog.capture("$pageview", { url: location.pathname + location.search });
  }, [posthog, location]);

  return (
    <QueryClientProvider client={queryClient}>
      <Notifications position="bottom-center" />
      <ModalsProvider>
        <ScrollRestoration />
        <AppMenu />
        <SpotlightSearch />
        <Outlet />
      </ModalsProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}
